import application from "stimulus_application";
import ClientsSearchController from "./clients_search_controller";
import "./clients_search.css";

application.register("clients-search", ClientsSearchController);
